/**
 * POSIX-style unique name generator: "report.pdf" → "report (1).pdf",
 * "report (2).pdf", … For folders the extension split is skipped so
 * "Photos" → "Photos (1)".
 *
 * `taken` is the set of names already present at the destination parent
 * (just leaf names, not full paths).
 */
export function generateUniqueName(
  desiredName: string,
  isFolder: boolean,
  taken: Set<string>,
): string {
  if (!taken.has(desiredName)) return desiredName;

  let base = desiredName;
  let ext = "";
  if (!isFolder) {
    const lastDot = desiredName.lastIndexOf(".");
    if (lastDot > 0) {
      base = desiredName.slice(0, lastDot);
      ext = desiredName.slice(lastDot);
    }
  }

  for (let i = 1; i < 10000; i++) {
    const candidate = `${base} (${i})${ext}`;
    if (!taken.has(candidate)) return candidate;
  }
  return `${base} (${Date.now()})${ext}`;
}
